<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.5239 12.2938L9.31076 17.0806C9.62019 17.39 10.1219 17.39 10.4313 17.0806L19.4805 8.0314C19.7897 7.72218 19.7897 7.22008 19.4805 6.91087C19.1713 6.60165 18.6692 6.60165 18.36 6.91087C18.36 6.91087 11.8452 13.4257 9.87103 15.3999C8.60731 14.1361 5.64444 11.1732 5.64444 11.1732C5.33522 10.864 4.83312 10.864 4.5239 11.1732C4.21469 11.4825 4.21469 11.9846 4.5239 12.2938Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'Tick'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
